import { ITEM_STATUS_COMPLETED } from 'constants/cart'

export default (item: App.CartItem) => item.status !== ITEM_STATUS_COMPLETED
